import {
  AfterViewInit,
  Component,
  DestroyRef,
  inject,
  Inject,
  Input,
  NgZone,
  OnDestroy,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { fadeInOut } from '@app/shared/animations/fadeInOut';
import { WINDOW } from '@ng-web-apis/common';
import { fromEvent, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { SocialMediaLinksComponent } from '../social-media-links.component';
import { AsyncPipe, isPlatformBrowser, NgClass } from '@angular/common';
import { SocialMediaLinksService } from '../social-media-links.service';
import { AgencySocialLinks } from '@app/back-office/models/agency';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-social-media-links-floating',
  templateUrl: './social-media-links-floating.component.html',
  styleUrls: ['./social-media-links-floating.component.scss'],
  animations: [fadeInOut],
  imports: [NgClass, SocialMediaLinksComponent, AsyncPipe],
})
export class SocialMediaLinksFloatingComponent implements AfterViewInit {
  destroyRef = inject(DestroyRef);
  platformId = inject(PLATFORM_ID);
  ngZone = inject(NgZone);
  socialLinksService = inject(SocialMediaLinksService);

  @Input() isOver = false;
  @Input() isRound = false;

  isSquareButton = signal<boolean>(false);
  agencySocialLinks$: Observable<AgencySocialLinks> = this.socialLinksService.getAgencySocialLinks();

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        // Run outside angular zone to avoid change detection on every scroll event
        fromEvent(window, 'scroll')
          .pipe(
            debounceTime(100),
            map(() => window.scrollY > 1),
            distinctUntilChanged(),
            tap(scrolled => {
              this.isSquareButton.set(scrolled);
            }),
            takeUntilDestroyed(this.destroyRef)
          )
          .subscribe();
      });
    }
  }
}
